import React from 'react';
import {Paper, Typography} from "@mui/material";

import CreateItemComponent from '../component/CreateItemComponent';
import ProcurementContainer from '../../procurement/containers/ProcurementContainer';
import ItemsList from '../lists/itemsList';


const ItemsPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Items
      </Typography>
      <Paper sx={{my: 5}}>
        <CreateItemComponent/>
      </Paper>
      <Paper sx={{my: 5}}>
        <ItemsList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default ItemsPage